// Mock data for NorthFold Kitchens & Wardrobes

export const projects = [
  {
    id: 1,
    title: "Minimal Luxury Kitchen",
    category: "luxury-kitchen",
    type: "Modular Kitchen",
    image: "https://images.unsplash.com/photo-1696986681606-b156ccd761c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBraXRjaGVufGVufDB8fHx8MTc3MTIzODA2NXww&ixlib=rb-4.1.0&q=85",
    description: "Contemporary kitchen with matte black cabinetry, marble countertops, and German hardware.",
    materials: ["Marine Plywood", "Matte Acrylic", "Quartz Countertop"]
  },
  {
    id: 2,
    title: "Natural Elegance Kitchen",
    category: "luxury-kitchen",
    type: "Modular Kitchen",
    image: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBraXRjaGVufGVufDB8fHx8MTc3MTIzODA2NXww&ixlib=rb-4.1.0&q=85",
    description: "Warm wood tones paired with white cabinetry for a timeless luxury aesthetic.",
    materials: ["HDHMR Boards", "PU Finish", "Soft-close Hardware"]
  },
  {
    id: 3,
    title: "Urban Modern Kitchen",
    category: "luxury-kitchen",
    type: "Modular Kitchen",
    image: "https://images.unsplash.com/photo-1611095210561-67f0832b1ca3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBraXRjaGVufGVufDB8fHx8MTc3MTIzODA2NXww&ixlib=rb-4.1.0&q=85",
    description: "Sleek gray palette with integrated appliances and seamless design.",
    materials: ["Marine Plywood", "Textured Laminates", "Anti-scratch Surfaces"]
  },
  {
    id: 4,
    title: "Contemporary Luxury Kitchen",
    category: "luxury-kitchen",
    type: "Modular Kitchen",
    image: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxtb2R1bGFyJTIwa2l0Y2hlbnxlbnwwfHx8fDE3NzEyMzgwNzN8MA&ixlib=rb-4.1.0&q=85",
    description: "Open plan kitchen with island, premium finishes, and natural light optimization.",
    materials: ["HDHMR Boards", "Matte Acrylic", "Quartz Countertop"]
  },
  {
    id: 5,
    title: "Smart Budget Kitchen",
    category: "smart-kitchen",
    type: "Modular Kitchen",
    image: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxtb2R1bGFyJTIwa2l0Y2hlbnxlbnwwfHx8fDE3NzEyMzgwNzN8MA&ixlib=rb-4.1.0&q=85",
    description: "Modern design with durable materials, optimal storage, and clean aesthetics.",
    materials: ["HDHMR Boards", "Matte Laminates", "Standard Hardware"]
  },
  {
    id: 6,
    title: "Efficient Modern Kitchen",
    category: "smart-kitchen",
    type: "Modular Kitchen",
    image: "/assets/images/Kitchen1.png",
    description: "Smart layout maximizing functionality without compromising on style.",
    materials: ["Plywood", "Textured Laminates", "Quality Hardware"]
  },
  {
    id: 7,
    title: "Walk-in Luxury Wardrobe",
    category: "wardrobe",
    type: "Wardrobe",
    image: "https://images.unsplash.com/photo-1672137233327-37b0c1049e77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3YXJkcm9iZXxlbnwwfHx8fDE3NzEyMzgxMDJ8MA&ixlib=rb-4.1.0&q=85",
    description: "Expansive walk-in wardrobe with organized sections and luxury finishes.",
    materials: ["Marine Plywood", "PU Finish", "Soft-close Drawers"]
  },
  {
    id: 8,
    title: "Modern Minimal Wardrobe",
    category: "wardrobe",
    type: "Wardrobe",
    image: "https://images.unsplash.com/photo-1765766600589-ddad380d6534?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB3YXJkcm9iZXxlbnwwfHx8fDE3NzEyMzgxMDJ8MA&ixlib=rb-4.1.0&q=85",
    description: "Clean built-in wardrobe with efficient space utilization and contemporary design.",
    materials: ["HDHMR Boards", "Matte Laminates", "Standard Hardware"]
  },
  {
    id: 9,
    title: "Sleek Built-in Wardrobe",
    category: "wardrobe",
    type: "Wardrobe",
    image: "/assets/images/Wardrobe.png",
    description: "White minimalist wardrobe perfect for modern bedroom interiors.",
    materials: ["Plywood", "Acrylic Finish", "Soft-close Hardware"]
  },
  {
    id: 10,
    title: "Integrated Storage Solution",
    category: "storage",
    type: "Storage Solutions",
    image: "/assets/images/Storage1.png",
    description: "Custom bedroom storage with built-in drawers and modern aesthetics.",
    materials: ["HDHMR Boards", "PU Finish", "Designer Hardware"]
  },
  {
    id: 11,
    title: "Modular Storage Unit",
    category: "storage",
    type: "Storage Solutions",
    image: "/assets/images/Storage2.png",
    description: "Contemporary cube storage with wood accents for versatile usage.",
    materials: ["Plywood", "Matte Laminates", "Standard Hardware"]
  },
  {
    id: 12,
    title: "Built-in Workspace Storage",
    category: "storage",
    type: "Storage Solutions",
    image: "/assets/images/Storage3.png",
    description: "Integrated bookshelf and workspace with seamless wall mounting.",
    materials: ["Marine Plywood", "Wood Veneer", "Concealed Mounting"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Premium Home Owner",
    location: "Model Town, Jalandhar",
    text: "NorthFold transformed our kitchen into a masterpiece. The attention to detail and quality of materials exceeded expectations. Worth every rupee.",
    rating: 5,
    project: "Luxury Modular Kitchen"
  },
  {
    id: 2,
    name: "Luxury Villa Owner",
    location: "Civil Lines, Jalandhar",
    text: "Professional team, timely execution, and premium quality. Our walk-in wardrobe is exactly what we envisioned. Highly recommended.",
    rating: 5,
    project: "Walk-in Wardrobe"
  },
  {
    id: 3,
    name: "Modern Home Owner",
    location: "Urban Estate, Jalandhar",
    text: "Amazing craftsmanship! They designed a beautiful kitchen that fits our budget without compromising on aesthetics. Very satisfied.",
    rating: 5,
    project: "Smart Budget Kitchen"
  }
];

export const services = [
  {
    id: 1,
    title: "Luxury Modular Kitchens",
    description: "Bespoke kitchen design with precision engineering, premium materials, and German hardware. Each kitchen is crafted to reflect your lifestyle with uncompromising attention to detail.",
    features: [
      "PU finish detailing with hand-polished surfaces",
      "CNC designed panels for perfect alignment",
      "Quartz & granite countertop options",
      "Soft-close German hardware systems",
      "Marine-grade plywood & High-density MDF structural boards",
      "Anti-scratch & moisture-resistant finishes"
    ]
  },
  {
    id: 2,
    title: "Designer Wardrobes",
    description: "From walk-in closets to space-efficient built-ins, our wardrobes combine luxury aesthetics with intelligent organization. Crafted for durability and timeless elegance.",
    features: [
      "Custom interior layouts with precision engineering",
      "Soft-close drawer mechanisms",
      "Matte acrylic & PU finishes",
      "LED lighting integration",
      "Premium designer accessories",
      "Modular organization systems"
    ]
  },
  {
    id: 3,
    title: "Smart Budget Solutions",
    description: "Value-focused design without compromise on quality. Our smart budget range combines modern aesthetics with durable construction and cost-efficient structural engineering.",
    features: [
      "Matte & high gloss laminate finishes",
      "Acrylic finish options",
      "Smart glass solutions",
      "Polymeric shutters for durability",
      "Membrane MR panels",
      "Cost-efficient structural engineering"
    ]
  },
  {
    id: 4,
    title: "Storage & Entertainment Units",
    description: "Custom storage solutions, TV units, and entertainment centers designed to complement your interiors. Seamless integration with modern living spaces.",
    features: [
      "Bespoke design & precision sizing",
      "German hardware systems for smooth operation",
      "Cable management integration",
      "Display & concealed storage options",
      "Premium finish coordination",
      "Wall-mounted & floor units with anti-scratch surfaces"
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "What materials do you use for modular kitchens?",
    answer: "We use premium materials including Marine-grade Plywood, High-density MDF boards, PU finishes, CNC-designed panels, Quartz and granite countertops, and Premium German hardware systems. All materials are selected for durability, moisture resistance, and long-term performance."
  },
  {
    id: 2,
    question: "Do you provide warranty on kitchen and wardrobe installations?",
    answer: "Yes, we provide a comprehensive 10-year structural guarantee on all our installations. Additionally, we offer 20 free post-installation services covering adjustments, maintenance checks, and minor repairs to ensure your kitchen or wardrobe remains in perfect condition."
  },
  {
    id: 3,
    question: "How long does a typical project take?",
    answer: "A standard modular kitchen installation typically takes 20-30 days from design approval to final installation. Wardrobe projects take 20-30 days from start to finish. Timelines may vary based on project complexity, customization requirements, and site conditions. We maintain strict adherence to agreed timelines."
  },
  {
    id: 4,
    question: "Do you offer custom design solutions?",
    answer: "Absolutely. Every project at NorthFold is custom-designed to match your space, lifestyle, and aesthetic preferences. Our design team creates detailed 3D visualizations and works closely with you through every stage to ensure the final product perfectly reflects your vision."
  },
  {
    id: 5,
    question: "What areas do you serve?",
    answer: "We serve PAN India, with our base operations in Jalandhar. For large-scale projects, we extend our services across the country. Contact us to discuss your location and project requirements."
  },
  {
    id: 6,
    question: "What is included in the 20 free services?",
    answer: "Our 20 free post-installation services include hardware adjustments, hinge tightening, drawer alignment, shutter realignment, handle replacements, minor repairs, cleaning guidance, and maintenance checks. These services are provided free of charge to ensure optimal performance of your installation."
  }
];

export const highlights = [
  {
    id: 1,
    title: "10-Year Structural Guarantee",
    description: "Comprehensive warranty coverage"
  },
  {
    id: 2,
    title: "20 Free Services",
    description: "Post-installation care included"
  },
  {
    id: 3,
    title: "35+ Years Experience",
    description: "Precision interior craftsmanship"
  }
];

export const processSteps = [
  {
    id: 1,
    step: "01",
    title: "Design Consultation",
    description: "We begin with understanding your vision, space, and requirements. Our design team creates 3D concepts tailored to your lifestyle and budget."
  },
  {
    id: 2,
    step: "02",
    title: "Precision Manufacturing",
    description: "Using advanced machinery and premium materials, we craft each component with precision in our state-of-the-art facility."
  },
  {
    id: 3,
    step: "03",
    title: "Expert Installation",
    description: "Our skilled installation team ensures seamless fitting with attention to every detail, delivering a flawless finished product."
  }
];
